import React, { useContext } from 'react';

import DocumentsContext from '@totem/components/documents/report/documentsContext';
import DocumentsTable from '@totem/components/documents/report/documentsTable';
import DocumentUploadButton from '@totem/components/documents/report/documentUploadButton';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const DocumentsPanel = () => {
  const { totalRecords } = useContext(DocumentsContext);

  return (
    <IBCard
      isCovered
      title={'Documents'}
      extra={
        <>
          <RecordCountBadge count={totalRecords} />
          &nbsp;&nbsp;&nbsp;
          <DocumentUploadButton />
        </>
      }
    >
      <DocumentsTable />
    </IBCard>
  );
};

export default DocumentsPanel;
